// src/pages/auth/Logout.jsx
import React, { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { UserContext } from '../../context/userContext';

const Logout = () => {
  const { setCurrentUser } = useContext(UserContext);
  const navigate = useNavigate();
  const [isLoggingOut, setIsLoggingOut] = useState(true);

  useEffect(() => {
    const performLogout = () => {
      // Clear any stored tokens or session data
      localStorage.removeItem('authToken');
      sessionStorage.removeItem('authToken');
      
      // Update context
      setCurrentUser(null);
      
      // Set a small delay for better UX
      setTimeout(() => {
        navigate('/login');
      }, 500);
    };

    performLogout();
  }, [setCurrentUser, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="max-w-md w-full space-y-8 bg-white p-10 rounded-xl shadow-md text-center">
        <div className="animate-pulse">
          <svg className="mx-auto h-12 w-12 text-primary" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
          </svg>
          <h2 className="mt-6 text-center text-2xl font-bold text-gray-900">Logging out...</h2>
          <p className="mt-2 text-center text-sm text-gray-600">
            Thank you for using our platform
          </p>
        </div>
      </div>
    </div>
  );
};

export default Logout;